export default __webpack_public_path__ + "static/media/our-services-edu-primary-01.7706296c.jpg";